var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1666 14.1666C19.1666 14.6666 18.8333 14.9999 18.3333 14.9999H1.66659C1.16659 14.9999 0.833252 14.6666 0.833252 14.1666C0.833252 13.6666 1.16659 13.3333 1.66659 13.3333C2.58325 13.3333 3.33325 12.5833 3.33325 11.6666V7.49992C3.33325 3.83325 6.33325 0.833252 9.99992 0.833252C13.6666 0.833252 16.6666 3.83325 16.6666 7.49992V11.6666C16.6666 12.5833 17.4166 13.3333 18.3333 13.3333C18.8333 13.3333 19.1666 13.6666 19.1666 14.1666ZM12.1666 17.9166C11.6666 18.7499 10.8333 19.1666 9.99992 19.1666C9.58325 19.1666 9.16659 19.0833 8.74992 18.8333C8.33325 18.5833 8.08325 18.3333 7.83325 17.9166C7.58325 17.4999 7.74992 16.9999 8.16659 16.7499C8.58325 16.4999 9.08325 16.6666 9.33325 17.0833C9.35848 17.1085 9.38371 17.1413 9.41125 17.1772L9.41126 17.1772C9.47469 17.2599 9.55038 17.3585 9.66659 17.4166C10.0833 17.6666 10.5833 17.4999 10.8333 17.0833C11.0833 16.6666 11.5833 16.5833 11.9999 16.7499C12.4166 16.9166 12.4166 17.4999 12.1666 17.9166ZM14.9999 11.6666C14.9999 12.2499 15.1666 12.8333 15.4166 13.3333H4.58325C4.83325 12.8333 4.99992 12.2499 4.99992 11.6666V7.49992C4.99992 4.74992 7.24992 2.49992 9.99992 2.49992C12.7499 2.49992 14.9999 4.74992 14.9999 7.49992V11.6666Z",
    fill: "#9C92E5",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1666 14.1666C19.1666 14.6666 18.8333 14.9999 18.3333 14.9999H1.66659C1.16659 14.9999 0.833252 14.6666 0.833252 14.1666C0.833252 13.6666 1.16659 13.3333 1.66659 13.3333C2.58325 13.3333 3.33325 12.5833 3.33325 11.6666V7.49992C3.33325 3.83325 6.33325 0.833252 9.99992 0.833252C13.6666 0.833252 16.6666 3.83325 16.6666 7.49992V11.6666C16.6666 12.5833 17.4166 13.3333 18.3333 13.3333C18.8333 13.3333 19.1666 13.6666 19.1666 14.1666ZM12.1666 17.9166C11.6666 18.7499 10.8333 19.1666 9.99992 19.1666C9.58325 19.1666 9.16659 19.0833 8.74992 18.8333C8.33325 18.5833 8.08325 18.3333 7.83325 17.9166C7.58325 17.4999 7.74992 16.9999 8.16659 16.7499C8.58325 16.4999 9.08325 16.6666 9.33325 17.0833C9.35848 17.1085 9.38371 17.1413 9.41125 17.1772L9.41126 17.1772C9.47469 17.2599 9.55038 17.3585 9.66659 17.4166C10.0833 17.6666 10.5833 17.4999 10.8333 17.0833C11.0833 16.6666 11.5833 16.5833 11.9999 16.7499C12.4166 16.9166 12.4166 17.4999 12.1666 17.9166ZM14.9999 11.6666C14.9999 12.2499 15.1666 12.8333 15.4166 13.3333H4.58325C4.83325 12.8333 4.99992 12.2499 4.99992 11.6666V7.49992C4.99992 4.74992 7.24992 2.49992 9.99992 2.49992C12.7499 2.49992 14.9999 4.74992 14.9999 7.49992V11.6666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_156)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#9C92E5",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutline);
export default __webpack_public_path__ + "static/media/bell_outline.6a646eb0bd79499f8ad25190a0b7210e.svg";
export { ForwardRef as ReactComponent };